export class Counter {
    idSubmit!: number;
}